import { render, staticRenderFns } from "./side-navbar-component.vue?vue&type=template&id=01e21923&scoped=true"
import script from "./side-navbar-component.vue?vue&type=script&setup=true&lang=ts"
export * from "./side-navbar-component.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./side-navbar-component.vue?vue&type=style&index=0&id=01e21923&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e21923",
  null
  
)

export default component.exports